import _cloneDeep from 'lodash/cloneDeep';
import _merge from 'lodash/merge';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import { buildChargebackTopEntitiesChart } from '../../util/DynamicChargebacksWidgets';
import { Entity } from 'sl-api-connector/types';
import { Widget as WidgetType } from 'src/types/application/widgetTypes';
import { INDEX_FIELDS, ENTITIES } from 'src/utils/entityDefinitions';
import buildShortagesSummaryWidgets from './ShortagesSummaryPageLayout';
import { buildDisputeManagementPageWidgets } from 'src/components/Layout/Beacon/OperationsPageLayout/DisputeManagementPageLayout';
import { onShortagesMode } from 'src/store/modules/user/selectors';
import ChargebackMetrics from 'src/components/BeaconV2Components/ExperimentalLayout/Operations/Chargebacks/ChargebackMetrics';

import ChargebacksSplineChart from 'src/components/BeaconV2Components/ExperimentalLayout/Operations/Chargebacks/ChargebacksSplineChart';
import ChargebackProductsList from 'src/components/BeaconV2Components/ExperimentalLayout/Operations/Chargebacks/ChargebackProductsList';
import { getWidgetBarChartStyles } from 'src/components/BeaconV2Components/styles/styles';
import { BEACON_GRID_TOP_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

interface PageLayoutParameters {
  app: any;
  tab: string;
  metricType: string;
  entity: Entity;
}

const buildChargeBackWidgets = ({ app, entity, weekIdField }: any, widgets: WidgetType[]) => {
  const indexName = 'chargebacks';

  widgets.push({
    name: 'chargebackMetrics',
    CustomComponent: ChargebackMetrics,
    view: {}
  });

  widgets.push(
    _merge(buildChargebackTopEntitiesChart({ indexName, entity, app, weekIdField }), {
      view: {
        container: {
          style: getWidgetBarChartStyles()
        }
      }
    })
  );

  widgets.push({
    name: 'chargebackSplineChart',
    CustomComponent: ChargebacksSplineChart,
    view: {
      container: {
        style: {
          marginBottom: `${BEACON_GRID_TOP_SPACING}px`
        }
      }
    }
  });

  // Table
  widgets.push({
    name: 'chargebackProductsList',
    CustomComponent: ChargebackProductsList,
    view: {
      container: {
        style: {
          marginBottom: `${BEACON_GRID_TOP_SPACING}px`
        }
      }
    }
  });
};

const getOperationsPageLayout = ({ app, tab, metricType, entity }: PageLayoutParameters) => {
  const indexName = tab;
  const weekIdField = _cloneDeep(INDEX_FIELDS.getField(app.name, indexName, 'weekId'));
  const retailerIdField = _cloneDeep(INDEX_FIELDS.getField(app.name, indexName, 'retailerId'));

  // Use indexName unless testing with shortages, then use shortagesIndexName
  const dataConfig = {
    indexName,
    retailerEntity: _cloneDeep(ENTITIES.beacon.retailer),
    categoryEntity: _cloneDeep(ENTITIES.beacon.category),
    relatedEntity: _cloneDeep(ENTITIES.beacon.brand),
    weekIdField,
    retailerIdField
  };
  const widgets: WidgetType[] = [];
  const enableComparision = true;
  const subscribedToShortages = onShortagesMode();
  switch (metricType) {
    case 'chargebacks':
      buildChargeBackWidgets({ app, entity, weekIdField }, widgets);
      break;
    case 'shortages':
      if (subscribedToShortages) {
        buildShortagesSummaryWidgets({ app, entity, weekIdField }, widgets);
      }
      break;

    case 'disputes':
      buildDisputeManagementPageWidgets(widgets);
      break;

    default:
      break;
  }

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparision,
    dataConfig,
    widgets
  };
};

export default getOperationsPageLayout;
